"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineOfCoverageDetailsEditor = void 0;
var react_1 = require("react");
var reducer_1 = require("./reducer");
var types_1 = require("./types");
var util_1 = require("./util");
function useLineOfCoverageDetailsEditor(_a) {
    var linesOfCoverageDetails = _a.linesOfCoverageDetails, onUpdate = _a.onUpdate;
    var lineOfCoverageDetailsRecords = react_1.useMemo(function () { return util_1.getRecords(linesOfCoverageDetails); }, [linesOfCoverageDetails]);
    var lineOfCoverageTypeFrequencyMap = react_1.useMemo(function () { return util_1.getTypeFrequencyMap(linesOfCoverageDetails); }, [linesOfCoverageDetails]);
    var lineOfCoverageTypeDisplayNameMap = react_1.useMemo(function () { return util_1.getTypeDisplayNameMap(linesOfCoverageDetails); }, [linesOfCoverageDetails]);
    var _b = react_1.useReducer(reducer_1.reducer, {
        lineOfCoverageDetailsRecords: lineOfCoverageDetailsRecords,
        lineOfCoverageTypeFrequencyMap: lineOfCoverageTypeFrequencyMap,
        lineOfCoverageTypeDisplayNameMap: lineOfCoverageTypeDisplayNameMap,
    }), state = _b[0], dispatch = _b[1];
    react_1.useEffect(function () {
        var updatedLineOfCoverageDetails = util_1.getLineOfCoverageDetails(state.lineOfCoverageDetailsRecords);
        onUpdate(updatedLineOfCoverageDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.lineOfCoverageDetailsRecords]);
    var addLineOfCoverageDetails = function (lineOfCoverageTypeDetails) {
        var linesOfCoverageDetailsFromPayload = lineOfCoverageTypeDetails.map(function (details) {
            var _a;
            return ({
                type: details.type,
                version: details.version,
                displayName: (_a = details.displayName) !== null && _a !== void 0 ? _a : '',
                data: {},
            });
        });
        dispatch({
            type: types_1.LineOfCoverageDetailsEditorActionType.ADD_LINES_OF_COVERAGE_DETAILS,
            payload: {
                linesOfCoverageDetails: linesOfCoverageDetailsFromPayload,
            },
        });
    };
    var removeLineOfCoverageDetails = function (identifier) {
        dispatch({
            type: types_1.LineOfCoverageDetailsEditorActionType.REMOVE_LINE_OF_COVERAGE_DETAILS,
            payload: {
                identifier: identifier,
            },
        });
    };
    var updateLineOfCoverageDetails = function (identifier, lineOfCoverageDetails) {
        dispatch({
            type: types_1.LineOfCoverageDetailsEditorActionType.UPDATE_LINE_OF_COVERAGE_DETAILS,
            payload: {
                identifier: identifier,
                lineOfCoverageDetails: lineOfCoverageDetails,
            },
        });
    };
    return {
        lineOfCoverageDetailsRecords: state.lineOfCoverageDetailsRecords,
        addLineOfCoverageDetails: addLineOfCoverageDetails,
        removeLineOfCoverageDetails: removeLineOfCoverageDetails,
        updateLineOfCoverageDetails: updateLineOfCoverageDetails,
    };
}
exports.useLineOfCoverageDetailsEditor = useLineOfCoverageDetailsEditor;
